import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Math.easing = {
  linear: function (t) { return t },
  easeInQuad: function (t) { return t * t },
  easeOutQuad: function (t) { return t * (2 - t) },
  easeInOutQuad: function (t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t },
  easeInCubic: function (t) { return t * t * t },
  easeOutCubic: function (t) { return (--t) * t * t + 1 },
  easeInOutCubic: function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 },
  easeInQuart: function (t) { return t * t * t * t },
  easeOutQuart: function (t) { return 1 - (--t) * t * t * t },
  easeInOutQuart: function (t) { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t },
  easeInQuint: function (t) { return t * t * t * t * t },
  easeOutQuint: function (t) { return 1 + (--t) * t * t * t * t },
  easeInOutQuint: function (t) { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t }
}

const appHeight = (height) => {
  const doc = document.documentElement
  if (height == undefined) {
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    document.body.style.height = `${window.innerHeight}px`
  } else {
    doc.style.setProperty('--app-height', `${height}px`)
    document.body.style.height = `${height}px`
  }
}

if (window.visualViewport) {
  window.visualViewport.addEventListener('scroll', (event) => { handleViewPort(event) });
  window.visualViewport.addEventListener('resize', (event) => { handleViewPort(event) });
}

function handleViewPort(event){
  requestAnimationFrame(() => {
    appHeight(event.target.height)
  })
}

appHeight()
window.addEventListener("resize", () => {
  appHeight()
}) 